import useGetAllBotInOne from "@/hooks/useGetAllBotInOne";
import { AnimatePresence, motion } from "framer-motion";
import { useCallback } from "react";

const ReadyToGoModal = ({
  onClose,
  onBuildBot,
  showRewardSection,
}: {
  onClose: () => void;
  onBuildBot: () => void;
  showRewardSection: boolean;
}) => {
  // Function to add !flex class to all support-doc-tooltip divs for 10 seconds

  // const triggerSupportDocTooltipFlex = useCallback(() => {
  //   const event = new Event('showSupportDocTooltipFlex');
  //   window.dispatchEvent(event);
  // }, []);

  const { data: allBotsData, isLoading: isBotListLoading } =
    useGetAllBotInOne();
  const triggerSupportDocTooltipFlex = useCallback(() => {
    const botCount = allBotsData?.data?.bots?.length ?? 1;
    if (!isBotListLoading && botCount === 1) {
      const event = new Event("showSupportDocTooltipFlex");
      window.dispatchEvent(event);
    }
  }, [isBotListLoading, allBotsData]);

  return (
    <AnimatePresence>
      <div
        // initial={{ opacity: 0 }}
        // animate={{ opacity: 1 }}
        // exit={{ opacity: 0 }}
        className="createbot-modal"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="flex-cnt mx-4 w-[680px] flex-col rounded-[10px] bg-[linear-gradient(180deg,_#74C18B_-38.63%,_#FFF_50%)] p-[60px]"
        >
          <SuccessIcon />

          <h2 className="mb-[10px] mt-[35px] text-[16px] font-medium leading-normal text-text-clr">
            All set! You're good to go!
          </h2>
          <p className="whitespace-pre-line text-center text-[14px] leading-normal text-[#999]">
            Thanks for sharing your details. We'll now create a personalized{" "}
            <br />
            bot tailored to your goals and company needs.
          </p>

          {showRewardSection && (
            <div className="mt-[30px] flex min-w-[353px] max-w-[407px] gap-[10px] rounded-[10px] bg-[#f9f9f9] p-[10px]">
              <div className="grid h-[44px] w-[44px] flex-shrink-0 place-items-center rounded-[15px] border border-[rgba(0,0,0,0.10)] bg-white">
                <GiftIconSvg />
              </div>
              <div className="flex flex-col gap-[6px]">
                <p className="text-[12px] leading-none text-[#666]">
                  Your reward is here
                </p>
                <p className="text-[14px] leading-[140%] text-[#444]">
                  {" "}
                  You have been awarded with{" "}
                  <span className="font-medium">50 free Messages</span> before
                  you have to add your own API key.
                </p>
              </div>
            </div>
          )}
          <button
            className="mt-[30px] rounded-[8px] bg-[#FB5F66] px-[30px] py-[10px] text-[14px] leading-[1.3] text-[#FFFFFF]"
            onClick={() => {
              onBuildBot();
              triggerSupportDocTooltipFlex();
            }}
          >
            Let's build your Bot
          </button>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default ReadyToGoModal;

export const SuccessIcon = () => (
  <svg
    width={133}
    height={133}
    viewBox="0 0 133 133"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx={66.2656} cy={66.5} r={66} fill="white" fillOpacity={0.2} />
    <circle
      cx={66.2658}
      cy={66.5002}
      r={57.8947}
      fill="white"
      fillOpacity={0.3}
    />
    <rect
      x={18.791}
      y={19.0273}
      width={94.9474}
      height={94.9474}
      rx={47.4737}
      fill="white"
      fillOpacity={0.5}
    />
    <rect x={42.2676} y={42.5} width={48} height={48} rx={24} fill="#31A754" />
    <path
      d="M76.6445 59.3078C76.6009 58.8451 76.3774 58.4181 76.0222 58.1185C75.6696 57.8601 75.2339 57.741 74.7989 57.784C74.3638 57.8271 73.96 58.0293 73.6649 58.3519L63.2323 70.885L57.5375 65.237C57.2057 64.9278 56.7668 64.7594 56.3133 64.7674C55.8598 64.7754 55.4272 64.9591 55.1064 65.2798C54.7857 65.6006 54.602 66.0332 54.594 66.4867C54.586 66.9402 54.7544 67.3791 55.0635 67.7109L62.0653 74.7127C62.3933 75.041 62.8382 75.2257 63.3023 75.2261C63.5475 75.2119 63.7873 75.1488 64.0077 75.0406C64.2281 74.9324 64.4247 74.7812 64.586 74.596L76.2556 60.5924C76.5485 60.2317 76.6881 59.7704 76.6445 59.3078Z"
      fill="white"
    />
  </svg>
);

export const GiftIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clipPath="url(#clip0_7999_95077)">
      <path
        d="M17.4323 6.33333H15.984C16.4551 5.918 16.8291 5.40407 17.0794 4.828C17.3297 4.25193 17.4502 3.62784 17.4323 3C17.4323 2.77899 17.3445 2.56702 17.1882 2.41074C17.0319 2.25446 16.82 2.16667 16.599 2.16667C16.3779 2.16667 16.166 2.25446 16.0097 2.41074C15.8534 2.56702 15.7656 2.77899 15.7656 3C15.7656 5.185 13.7898 5.94167 12.2873 6.20083C12.8419 5.21755 13.1757 4.12531 13.2656 3C13.2656 2.33696 13.0022 1.70107 12.5334 1.23223C12.0646 0.763392 11.4287 0.5 10.7656 0.5C10.1026 0.5 9.4667 0.763392 8.99786 1.23223C8.52902 1.70107 8.26562 2.33696 8.26562 3C8.35555 4.12531 8.68939 5.21755 9.24396 6.20083C7.74146 5.94167 5.76562 5.185 5.76562 3C5.76562 2.77899 5.67783 2.56702 5.52155 2.41074C5.36527 2.25446 5.15331 2.16667 4.93229 2.16667C4.71128 2.16667 4.49932 2.25446 4.34304 2.41074C4.18676 2.56702 4.09896 2.77899 4.09896 3C4.08105 3.62784 4.20152 4.25193 4.45182 4.828C4.70212 5.40407 5.07612 5.918 5.54729 6.33333H4.09896C3.2149 6.33333 2.36706 6.68452 1.74194 7.30964C1.11681 7.93476 0.765625 8.78261 0.765625 9.66667L0.765625 10.5C0.765625 10.942 0.94122 11.3659 1.25378 11.6785C1.56634 11.9911 1.99026 12.1667 2.43229 12.1667V16.3333C2.43361 17.438 2.87303 18.497 3.65414 19.2782C4.43526 20.0593 5.4943 20.4987 6.59896 20.5H14.9323C16.037 20.4987 17.096 20.0593 17.8771 19.2782C18.6582 18.497 19.0976 17.438 19.099 16.3333V12.1667C19.541 12.1667 19.9649 11.9911 20.2775 11.6785C20.59 11.3659 20.7656 10.942 20.7656 10.5V9.66667C20.7656 8.78261 20.4144 7.93476 19.7893 7.30964C19.1642 6.68452 18.3163 6.33333 17.4323 6.33333ZM10.7656 2.16667C10.9866 2.16667 11.1986 2.25446 11.3549 2.41074C11.5112 2.56702 11.599 2.77899 11.599 3C11.4984 3.88569 11.2146 4.74076 10.7656 5.51083C10.3167 4.74076 10.0329 3.88569 9.93229 3C9.93229 2.77899 10.0201 2.56702 10.1764 2.41074C10.3326 2.25446 10.5446 2.16667 10.7656 2.16667ZM2.43229 9.66667C2.43229 9.22464 2.60789 8.80072 2.92045 8.48816C3.23301 8.17559 3.65693 8 4.09896 8H9.93229V10.5H2.43229V9.66667ZM4.09896 16.3333V12.1667H9.93229V18.8333H6.59896C5.93592 18.8333 5.30003 18.5699 4.83119 18.1011C4.36235 17.6323 4.09896 16.9964 4.09896 16.3333ZM17.4323 16.3333C17.4323 16.9964 17.1689 17.6323 16.7001 18.1011C16.2312 18.5699 15.5953 18.8333 14.9323 18.8333H11.599V12.1667H17.4323V16.3333ZM11.599 10.5V8H17.4323C17.8743 8 18.2982 8.17559 18.6108 8.48816C18.9234 8.80072 19.099 9.22464 19.099 9.66667V10.5H11.599Z"
        fill="#FB5F66"
      />
    </g>
    <defs>
      <clipPath id="clip0_7999_95077">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(0.765625 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
